module.exports = __webpack_public_path__ + "static/bannner-internacionalismo-17-fdb964dedc1dcd567cd5953a41b15218.png";